module.exports = __webpack_public_path__ + "img/portraits_14_V.6f260020.webp";